import * as z from "zod";

export const CategorySchema = z
  .object({
    categoryId: z.string().nullable(),
    name: z.string().nullable(),
    color: z.string().nullable(),
    secondaryColor: z.string().nullable(),
  })
  .partial({ categoryId: true });

export const Category = CategorySchema;
export type Category = z.infer<typeof CategorySchema>;
